import { IConfigName } from './interface/field-type-object';

interface IDefaultDataObject {
  configName: IConfigName;
  required: boolean;
  type: string;
}

const defaultData: IDefaultDataObject = {
  configName: IConfigName.Range,
  required: false,
  type: 'range',
};

interface IDefaultConfigObject {
}

const defaultConfig: IDefaultConfigObject = {

};

const value = {
  title: 'Date/Time Range',
  icon: {
    black: require('../../icons/black/date-time-range.png'),
    white: require('../../icons/white/date-time-range.png'),
    blue: require('../../icons/blue/date-time-range.png'),
  },
  style: {
    width: '20px',
    height: '20px'
  },
  defaultData,
  defaultConfig
}

export default value;